import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  list: {
    maxHeight: theme.spacing(28),
    overflowY: 'auto',
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    padding: theme.spacing(1.75, 3),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.spacing(1.25),
    marginBottom: theme.spacing(2),
  },
  usernameBlock: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  username: {
    marginLeft: theme.spacing(1),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  score: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  prize: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
